<template>
  <div class="screen-my-mission wow fadeInUp">
    <div class="list-misson-center">
      <div class="star-zone">
        <img
          class="small-star-1"
          src="../../../../assets/my-mission.png"
          alt=""
          srcset=""
        />
      </div>

      <div class="content-mission">
        <div class="list-mission-today 'wow fadeInRight">
          <div
            v-for="(item, index) in myMission"
            :key="index"
            class="item-mission"
          >
            <div class="image-mission">
              <img :src="item.image" alt="" srcset="" />
            </div>
            <div class="item-description-mission">
              <div class="item-name-mission">{{ item.name }}</div>

              <div class="progress-point">
                <div>{{ item.point }}</div>
                <img src="../../../../assets/startPoint.svg" />
                <v-progress-linear :value="item.percent"></v-progress-linear>
              </div>
            </div>
            <div class="button-executed">
              <button v-if="!item.isFinish" @click="executeMission(item)">
                Thực Hiện
              </button>
              <button disabled v-if="item.isFinish">Đã Xong</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mdiPlayCircleOutline } from "@mdi/js";
import { call } from "vuex-pathify";
export default {
  data() {
    return {
      mdiPlayCircleOutline: mdiPlayCircleOutline,
      dialog: true,
      showcase_id: this.$route.query.showcase_id,
      myMission: [],
    };
  },
  async mounted() {
    this.myMission = JSON.parse(localStorage.getItem("MyMission")) || [];
    document.getElementById("footer").style.display = "none";
    if (this.myMission.length == 0) {
      this.myMission = [
        {
          name: "Máy in Laser Brother HL-L2321D",
          id: "may_in_wifi",
          image:
            "https://static.vieon.vn/ai-storage/ai_vlz/production/branding_data/4753447f-df64-4cbf-ab5e-5c9cd8c2456a/may-in-wifi.jpg",
          description:
            "Máy in Laser Brother HL-L2321D được thiết kế dành riêng cho các công ty doanh nghiệp. ",
          url: "https://cellphones.com.vn/may-in-laser-brother-hl-l2321d.html?gclid=CjwKCAiAkfucBhBBEiwAFjbkr_LawMJ20Iq4e7FoVBWM6dlpbJOOizQDtz7xlFm-hJv-FJl4SwB4vRoCGhwQAvD_BwE",
          time: 2,
          timeCount: 0,
          point: 20,
          percent: 0,
          isFinish: false,
        },
        {
          name: "Tủ lạnh Samsung Inverter 655 lít RS62R5001M9/SV",
          id: "tulanh",
          image:
            "https://cdn.nguyenkimmall.com/images/thumbnails/1920/532/detailed/664/10046275-1.jpg",
          description: "Thiết kế sang trọng làm nổi bật không gian nội thất",
          url: "https://www.nguyenkim.com/tu-lanh-hitachi-inverter-584-lit-r-fm800gpgv2-gs.html",
          time: 1,
          timeCount: 0,
          point: 20,
          percent: 0,
          isFinish: false,
        },
        {
          name: "Volkswagen New Beetle Convertible 2009 NK Mexico 2.5L",
          id: "xe_vw",
          image:
            "https://s.bonbanh.com/uploads/users/494936/car/4735251/m_1670896480.954.jpg",
          description: "Tủ lạnh Samsung Inverter 655 lít RS62R5001M9/SV",
          url: "https://bonbanh.com/ha-noi/oto/volkswagen-new_beetle-2.5-nam-2009",
          time: 1,
          timeCount: 0,
          point: 20,
          percent: 0,
          isFinish: false,
        },
        {
          name: "Sofa Porto da 3 chỗ hiện đại mẫu NW720",
          id: "sofa",
          image:
            "https://nhaxinh.com/wp-content/uploads/2021/10/sofa_da_3_cho_porto_1.jpg",
          description:
            "Sofa Porto da 3 chỗ hiện đại mẫu NW720 với đường may tinh tế gấp nếp hai bên tay sofa mang lại cảm giác dễ chịu cho không gian phòng khách. Điểm nhấn của sofa là inox mạ gold trang trí bên thành sofa rất vững chắc.",
          url: "https://nhaxinh.com/san-pham/sofa-porto-3-cho-hien-dai-da/",
          time: 1,
          timeCount: 0,
          point: 20,
          percent: 0,
          isFinish: false,
        },
      ];
      localStorage.setItem("MyMission", JSON.stringify(this.myMission));
    }
    console.log(this.myMission);
  },
  methods: {
    getDetailShowcase: call("showcase/getDetailShowcase"),
    executeMission(mission) {
      localStorage.setItem("MissionDetails", JSON.stringify(mission));
      this.$router.push(
        `/showcase/demo-game-ui?showcase_id=0dee6571-4986-4236-836a-fa479ecbcea4`
      );
    },
    pushToPageRedeem() {
      this.$router.push({ name: "AwardMision" });
    },
  },
};
</script>

<style lang="scss">
@import "./screen-my-mission.scss";
@import url("https://fonts.googleapis.com/css2?family=Goldman&display=swap");
</style>
